
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import './QMSFeedbackDetails.scss';
import moment from 'moment';
import { format, parseJSON } from 'date-fns';
import Select from "react-select";
import Box from '@mui/material/Box';
import styled from '@emotion/styled';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import {Button, FormGroup, Label} from "reactstrap";
import Toolbar from '@mui/material/Toolbar';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import { CircularProgress } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import { rowOptions, downloadExcel, validateDate} from '../../../utils/Helper'
import { useSelector, useDispatch } from 'react-redux';
import {ReactComponent as DownloadIcon} from "../../../assets/images/CommonComponent/downloads.svg"
import { downloadQMSFeedbackDetails, getQMSFeedbackDetails } from '../../../redux/actions/ReportAction/QMSFeebdackDetailReportAction/QMSFeebdackDetailReportAction';
import DatePicker from '../../../components/DatePicker/DatePicker';
import { tabKeys } from '../../../Config/Constant';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))

const headCells = [
    { 
        label: "FIRST NAME",
        id: "first_name", 
        disableSorting: true,
        width: '200px'
    },
    { 
        label: "LAST NAME",
        id: "last_name", 
        disableSorting: true,
        width: '200px' 
    },
    { 
        label: "ROOM NO.",
        id: "room_no", 
        disableSorting: true,
        width: '140px' 
    },
    { 
        label: "CHECK IN",
        id: "check_in", 
        disableSorting: true,
        width: '190px' 
    },
    { 
        label: "CHECK OUT",
        id: "check_out", 
        disableSorting: true,
        width: '190px' 
    },
    { 
        label: "FEEDBACK DATE",
        id: "feedback_date", 
        disableSorting: true,
        width: '190px' 
    },
    { 
        label: "OVERALL WELLNESS OBJECTIVE",
        id: "overall_wellness_objective_user_input", 
        disableSorting: true,
        width: '200px' 
    },
    { 
        label: "OUTCOME ACHIEVED",
        id: "overall_wellness_objective_rating", 
        disableSorting: true,
        width: '130px' 
    },
    { 
        label: "PHYSICAL HEALTH OBJECTIVE",
        id: "physical_health_objective_user_input", 
        disableSorting: true,
        width: '200px' 
    },
    { 
        label: "OUTCOME ACHIEVED",
        id: "physical_health_objective_rating", 
        disableSorting: true,
        width: '130px' 
    },
    { 
        label: "MENTAL HEALTH OBJECTIVE",
        id: "mental_health_objective_user_input", 
        disableSorting: true,
        width: '200px' 
    },
    { 
        label: "OUTCOME ACHIEVED",
        id: "mental_health_objective_rating", 
        disableSorting: true,
        width: '130px' 
    },
    { 
        label: "WELLNESS CONSULTANT PRE-ARRIVAL",
        id: "wellness_consultant_pre-arrival_user_input", 
        disableSorting: true,
        width: '220px' 
    },
    { 
        label: "RATE",
        id: "wellness_consultant_pre-arrival_rating", 
        disableSorting: true,
        width: '100px' 
    },
    { 
        label: "AYURVEDA DOCTOR",
        id: "ayurveda_doctor_user_input", 
        disableSorting: true,
        width: '190px' 
    },
    { 
        label: "RATE",
        id: "ayurveda_doctor_rating", 
        disableSorting: true,
        width: '100px' 
    },
    { 
        label: "YOGA & MEDITATION",
        id: "yoga_&_meditation_guide_user_input", 
        disableSorting: true,
        width: '200px' 
    },
    { 
        label: "RATE",
        id: "yoga_&_meditation_guide_rating", 
        disableSorting: true,
        width: '100px' 
    },
    { 
        label: "PHYSIOTHERAPIST",
        id: "physiotherapist_user_input", 
        disableSorting: true,
        width: '190px' 
    },
    { 
        label: "RATE",
        id: "physiotherapist_rating", 
        disableSorting: true,
        width: '100px' 
    },
    { 
        label: "EMOTION HEALER",
        id: "emotional_healer_user_input", 
        disableSorting: true,
        width: '120px' 
    },
    { 
        label: "RATE",
        id: "emotional_healer_rating", 
        disableSorting: true,
        width: '100px' 
    },
    { 
        label: "TRADITIONAL CHINESE MEDICINE DOCTOR",
        id: "traditional_chinese_medicine_doctor_user_input", 
        disableSorting: true,
        width: '200px' 
    },
    { 
        label: "RATE",
        id: "traditional_chinese_medicine_doctor_rating", 
        disableSorting: true,
        width: '100px' 
    },
    { 
        label: "FITNESS TRAINER ",
        id: "personal_fitness_traine_user_input", 
        disableSorting: true,
        width: '190px' 
    },
    { 
        label: "RATE",
        id: "personal_fitness_traine_rating", 
        disableSorting: true,
        width: '100px' 
    },
    { 
        label: "PLEASE RATE THE QUALITY AND EXPERTISE OF TREATMENT THERAPISTS",
        id: "qus_3_rating", 
        disableSorting: true,
        width: '250px' 
    },
    { 
        label: "ANY THERAPIST/S THAT YOU WOULD LIKE TO SPECIALLY RECOGNISE?",
        id: "qus_4_user_input", 
        disableSorting: true,
        width: '250px' 
    },
    { 
        label: "IF YOU ATTENDED THE DAILY GROUP YOGA AND MEDITATION, PLEASE RATE THE SESSIONS",
        id: "qus_5_rating", 
        disableSorting: true,
        width: '270px' 
    },
    { 
        label: "IF YOU ATTENDED THE DAILY GROUP VEDANTA SESSIONS, PLEASE RATE THE SESSIONS",
        id: "qus_5_rating", 
        disableSorting: true,
        width: '260px' 
    },
    { 
        label: "PLEASE RATE ANANDA'S WELLNESS CUISINE IMPACT ON WELLBEING AND PROGRAMME OBJECTIVE",
        id: "qus_7_rating", 
        disableSorting: true,
        width: '290px' 
    },
    { 
        label: "QUALITY OF PRESENTATION",
        id: "quality_and_presentation_rating", 
        disableSorting: true,
        width: '170px' 
    },
    { 
        label: "RATE YOUR OVERALL EXPERIENCE",
        id: "qus_9_rating", 
        disableSorting: true,
        width: '180px' 
    },
    // { 
    //     label: "WHAT ARE THE HIGHLIGHTS OF YOUR ANANDA EXPERIENCE?",
    //     id: "qus_10_user_input", 
    //     disableSorting: true,
    //     width: '220px' 
    // },
    { 
        label: "WHAT COULD WE DO TO IMPROVE YOUR EXPERIENCE?",
        id: "qus_11_user_input", 
        disableSorting: true,
        width: '230px' 
    },
    { 
        label: "HOW LIKELY ARE YOU TO RECOMMEND ANANDA'S EXPERIENCE?",
        id: "qus_12_rating", 
        disableSorting: true,
        width: '240px' 
    },
    // { 
    //     label: "GUEST RECOMMENDATIONS",
    //     id: "qus_12_user_input", 
    //     disableSorting: true,
    //     width: '210px' 
    // },
    { 
        label: "ROOM",
        id: "room_user_input", 
        disableSorting: true,
        width: '100px' 
    },
    { 
        label: "RESTAURANT / LOUNGE",
        id: "restaurant/lounge_rating", 
        disableSorting: true,
        width: '140px' 
    },
    { 
        label: "OTHER AREAS",
        id: "other_areas_rating", 
        disableSorting: true,
        width: '120px' 
    },
    { 
        label: "RESERVATIONS",
        id: "reservations_rating", 
        disableSorting: true,
        width: '170px' 
    },
    { 
        label: "ARRIVAL & WELCOME",
        id: "arrival_&_welcome_rating", 
        disableSorting: true,
        width: '150px' 
    },
    { 
        label: "HOUSEKEEPING",
        id: "housekeeping_rating", 
        disableSorting: true,
        width: '180px' 
    },
    { 
        label: "DINING",
        id: "dining_rating", 
        disableSorting: true,
        width: '140px' 
    },
    { 
        label: "SPA",
        id: "spa_rating", 
        disableSorting: true,
        width: '90px' 
    },
    { 
        label: "IT & WIFI",
        id: "it_&_wifi_rating", 
        disableSorting: true,
        width: '120px' 
    },
    { 
        label: "IF THERE ARE ANY STAFF MEMBERS WHO HAVE PROVIDED YOU WITH EXCEPTIONAL SERVICE PLEASE LIST THEIR NAMES:",
        id: "qus_15_user_input", 
        disableSorting: true,
        width: '330px' 
    }
  ];
  

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell, index) =>
                (<TableCell
                    key={index}
                    align='left'
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                    sx={{verticalAlign: 'top', minWidth: headCell.width, maxWidth: headCell.width}}
                >
                    <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        hideSortIcon={headCell.id === 'action' ? true : false}
                    >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>)
                )}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['', 'asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { setShowLoader, activeTab } = props;
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    let {downloadLoader} =   useSelector(state => state?.qmsFeedbackDetailsReducer);
    const [searchText, setSearchText] = useState(searchParams.get('filter_text') ||'');
    const [fromDate, setFromDate] = useState(searchParams.get('filter_from') || format(new Date(), "yyyy-MM-01"));
    const [toDate, setToDate] = useState(searchParams.get('filter_to') || format(new Date(), "yyyy-MM-dd"));

    useEffect(() => {
        if (activeTab == tabKeys.reports.QMS_FEEDBACK_REPORT) {
            setSearchText(searchParams.get('filter_text') || '');
            setFromDate(searchParams.get('filter_from') || format(new Date(), "yyyy-MM-01"));
            setToDate(searchParams.get('filter_to') || format(new Date(), "yyyy-MM-dd"));
        }
    }, [activeTab, searchParams]);

    const handleChangeSearch = (e) => {
        setShowLoader(true);
        const newSearchText = e.target.value;
        setSearchText(newSearchText);
        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('filter_text', newSearchText);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }

    const changeFromDate = (val) => {
        setShowLoader(true);
        const formattedDate = format(val, "yyyy-MM-dd");
        setFromDate(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate && formattedDate !== format(new Date(), "yyyy-MM-01")) {
            newParams.set('filter_from', formattedDate);
        } else {
            newParams.delete('filter_from');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }

    const changeToDate = (val) => {
        setShowLoader(true);
        const formattedDate = format(val, "yyyy-MM-dd");
        setToDate(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate && formattedDate !== format(new Date(), "yyyy-MM-dd")) {
            newParams.set('filter_to', formattedDate);
        } else {
            newParams.delete('filter_to');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }

    const downloadTableData = ()=>{
            let d = {}
            const onSuccessCallback = (data)=>{
                downloadExcel({data, fileName: `Feedback Report - ${format(new Date(fromDate), 'dd-MM-yyyy')} to ${format(new Date(toDate), 'dd-MM-yyyy')}.xlsx`})
              }
    
            dispatch(downloadQMSFeedbackDetails({
                ...d,
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('rowsPerPage') || 10,
                "filter_text": searchParams.get('filter_text') || '',
                "filter_from": searchParams.get('filter_from') || format(new Date(), "yyyy-MM-01"),
                "filter_to": searchParams.get('filter_to') || format(new Date(), "yyyy-MM-dd"),
                "order": searchParams.get('order') || '',
                "orderBy": searchParams.get('orderBy') || '',
                onSuccessCallback
            }))
        }

    return (
        <>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },

            }}
            >
                <div className='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Feedback Report
                    </MainHeading>
                </div>
                <div className='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-9 col-xxl-9 LevelDiv'>
                    <div className='DurationDiv d-flex align-items-center'>
                        <Label>Date:</Label>

                        <DatePicker
                            onChange={date => { changeFromDate(date) }}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            value={new Date(moment(fromDate, "YYYY-MM-DD").format('MM-DD-YYYY'))}
                            maxDate={new Date()}
                            popperPlacement={"bottom"}
                            width={'140px'}
                            height={'48px'}
                        />
                        <div className='mx-2'>to</div>
                        <DatePicker
                            onChange={date => { changeToDate(date) }}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            value={new Date(moment(toDate, "YYYY-MM-DD").format('MM-DD-YYYY'))}
                            minDate={new Date((moment(fromDate, "YYYY-MM-DD").add(1, 'days')).format('MM-DD-YYYY'))}
                            maxDate={new Date()}
                            popperPlacement={"bottom"}
                            width={'140px'}
                            height={'48px'}
                        />
                    </div>
                    <div className="separator"></div>

                    {/* <div className="mr-sm-2 searchDiv class-search ">
                        <input
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            value={searchText}
                            onChange={handleChangeSearch}
                        ></input>
                    </div> */}

                    <Button className="btn btn-primary  download-btn " disabled={downloadLoader} type="submit" onClick={downloadTableData}>
                        <span className="btn-icon">
                            {
                                !downloadLoader ?
                                <>
                                    <DownloadIcon fontSize={'17px'} className='mr-1' /> 
                                </>
                                :
                                <CircularProgress size={13} className='mt-1 mr-1' sx={{color: 'white'}} />
                            }
                        </span>
                        Download Excel
                    </Button>
                </div>
            </Toolbar>
            <Divider />
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const QMSFeedbackDetailsTable = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [order, setOrder] = useState(searchParams.get('order') ||'');
    const [orderBy, setOrderBy] = useState(searchParams.get('orderBy') ||'');
    const [selected, setSelected] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('rowsPerPage')) || 10);
    const [qmsFeedbackDetailsMainData, setqmsFeedbackDetailsMainData] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const qmsFeedbackDetails = useSelector(state => state?.qmsFeedbackDetailsReducer);
    const qmsFeedbackDetailsDataRes = useSelector(state => state?.qmsFeedbackDetailsReducer?.qmsFeedbackDetails);
    const { activeTab } = props;
    const dispatch = useDispatch();

    useEffect(()=>{
        if(!qmsFeedbackDetails.loading)
            setShowLoader(false)
        if(!qmsFeedbackDetails.loading && !qmsFeedbackDetailsDataRes?.data && !qmsFeedbackDetails.error){
            setShowLoader(true)
        }
    }, [qmsFeedbackDetails.loading])

    useEffect(() => {
        if (activeTab == tabKeys.reports.QMS_FEEDBACK_REPORT) {
            const sendRequest = {
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('rowsPerPage') || 10,
                "filter_text": searchParams.get('filter_text') || '' ,
                "filter_from": searchParams.get('filter_from') || format(new Date(), "yyyy-MM-01"),
                "filter_to": searchParams.get('filter_to') || format(new Date(), "yyyy-MM-dd"),
                "order": searchParams.get('order') || '',
                "orderBy": searchParams.get('orderBy') || ''
            };
            dispatch(getQMSFeedbackDetails(sendRequest));
        }else{
          setOrder(searchParams.get('order') || '');
          setOrderBy(searchParams.get('orderBy') || '');
          setRowsPerPage(10)
        }
    }, [activeTab, searchParams]);
    
    useEffect(() => {
        if (qmsFeedbackDetails.error !== "Ananda program feedback data does not exists") {
            setqmsFeedbackDetailsMainData(qmsFeedbackDetailsDataRes && qmsFeedbackDetailsDataRes?.data);
        } else {
            setqmsFeedbackDetailsMainData('');
        }
    }, [qmsFeedbackDetailsDataRes, qmsFeedbackDetails])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        const newParams = new URLSearchParams(searchParams);
        if (property) {
            newParams.set('orderBy', property);
        } else {
            newParams.delete('orderBy');
        }
        newParams.set('order', newOrder);
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = qmsFeedbackDetailsDataRes && qmsFeedbackDetailsMainData.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };


    const handleChangePageNext = () => {
        setShowLoader(true)
        const nextPage = (qmsFeedbackDetailsDataRes?.current_page_no || 0) + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', nextPage.toString());
        setSearchParams(newParams, { replace: true });
    };
    
    const handleChangePagePrev = () => {
        setShowLoader(true)
        const prevPage = (qmsFeedbackDetailsDataRes?.current_page_no || 2) - 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', prevPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true);
        const newRowsPerPage = parseInt(event.value, 10);
        setRowsPerPage(event.value);
        const newParams = new URLSearchParams(searchParams);
        if (newRowsPerPage !== 10) {
            newParams.set('rowsPerPage', newRowsPerPage.toString());
        } else {
            newParams.delete('rowsPerPage');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    };


    return (
      <Box sx={{ width: '100%' }} className="QMSFeedbackDetailsBox h-100">
      <Paper className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
              <EnhancedTableToolbar 
                  numSelected={selected.length} 
                  showLoader={showLoader}
                  setShowLoader={setShowLoader}
                  activeTab ={activeTab}
              />
          {
              showLoader ?
              <div className='w-100 text-center py-5'>
                  <CircularProgress sx={{'color': '#74613C'}}/>
              </div>
              :
              <>
                  
                  {qmsFeedbackDetailsMainData   ? <TableContainer sx={{ pt: 0, pr: 3, pb: 3, pl: 3, height: '100%' }}>
                      <Table
                          sx={{ minWidth: 750 }}
                          aria-labelledby="tableTitle"
                          stickyHeader
                          size='small'
                      >
                          <EnhancedTableHead
                              numSelected={selected.length}
                              order={order}
                              orderBy={orderBy}
                              onSelectAllClick={handleSelectAllClick}
                              onRequestSort={handleRequestSort}
                              rowCount={qmsFeedbackDetailsDataRes && qmsFeedbackDetailsMainData?.length}
                          />
                          <TableBody>
                              {
                                  qmsFeedbackDetailsMainData
                                      .map((row, index) => {
                                          const labelId = `enhanced-table-checkbox-${index}`;
                                          return (
                                              <React.Fragment key={index}>
                                                  <TableRow hover onClick={(event) => handleClick(event, row.title)} role="checkbox"
                                                      tabIndex={-1}
                                                      key={index}
                                                      >
                                                      {
                                                          headCells?.map((item, index)=>{
                                                              return (
                                                                  <TableCell key={index} sx={{verticalAlign: 'top'}} align="left">
                                                                      {
                                                                          validateDate(row[item.id]) ?
                                                                          moment(row[item.id]).format(item.id!=='check_out' && item.id!=='check_in' ?'DD MMM, YYYY hh:mm A': 'DD MMM, YYYY') :
                                                                          row[item.id] || '-'
                                                                      }
                                                                  </TableCell> 
                                                              )
                                                          })
                                                      }
                                                    
                                                  </TableRow>
                                              </React.Fragment>
                                          );
                                      })}
                          
                          </TableBody>
                      </Table>
                  </TableContainer>
                  : <div className='text-center w-100 text-muted mt-3'>No Records</div>}
              </>
          }
          </Paper>
          {
              qmsFeedbackDetailsMainData
              &&
              <div className='paginationBlock'>
                  <div className='textData'><p>Items per page: </p></div>
                  <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                      <Select
                          placeholder={rowsPerPage}
                          className="react-select"
                          classNamePrefix="react-select"
                          value={rowsPerPage}
                          options={rowOptions}
                          isSearchable={false}
                          onChange={handleChangeRowsPerPage}
                          theme={(theme) => ({
                              ...theme,
                              colors: {
                                  ...theme.colors,
                                  primary25: '#F5F5F5',
                                  primary: '#74613C',
                              },
                          })}
                          menuPlacement="top"
                          menuPosition="fixed"
                          styles={{
                              menu: (base) => ({
                                  ...base,
                                  top: 'auto',
                                  bottom: 0,
                              }),
                          }}
                      />
                  </FormGroup>
                  {qmsFeedbackDetailsDataRes && <p className='endText'>   {qmsFeedbackDetailsDataRes?.start} - {qmsFeedbackDetailsDataRes?.end} of {qmsFeedbackDetailsDataRes?.total}</p>}
                  <p>                         
                    <button className={`btnPrev ${qmsFeedbackDetailsDataRes?.current_page_no === 1 ? "opacityBtns" : ''}`} disabled={qmsFeedbackDetailsDataRes?.current_page_no === 1} onClick={() => { handleChangePagePrev() }}>
                        <ArrowBackIosNewSharpIcon className='iconBtn' />
                    </button> 
                    <button className={`btnPrev ${qmsFeedbackDetailsDataRes?.current_page_no === qmsFeedbackDetailsDataRes?.total_pages ? "opacityBtns" : ''}`} disabled={qmsFeedbackDetailsDataRes?.current_page_no === qmsFeedbackDetailsDataRes?.total_pages} onClick={() => { handleChangePageNext() }}>
                        <ArrowForwardIosSharpIcon className='iconBtn' />
                    </button></p>
              </div>   
          }
      </Box>
    );
}
export default QMSFeedbackDetailsTable;